import React from 'react'
import './assets/styles/main.scss'
import './styles/page-layout.css'
//Routing
import { Route, Routes } from 'react-router-dom'
import ProtectedRoutes from './components/routes/protected-routes'
//callbacks
import OAuthCallback from './components/oauth-callback'
//Layouts
import MainLayout from './layouts/MainLayout/MainLayout'
// Pages
import OrdersPage from './pages/OrdersPage/OrdersPage'
import InventaryPage from './pages/InventaryPage/InventaryPage'
import PricesPage from './pages/PricesPage/PricesPage'
import CatalogPage from './pages/CatalogPage/CatalogPage'
import LogsPage from './pages/LogsPage/LogsPage'
import DetailLogPage from './pages/DetailLogPage/DetailLogPage'

const App: React.FC = () => {
  return (
    <main>
      <Routes>
        <Route path="/callback" element={<OAuthCallback />} />
        <Route element={<ProtectedRoutes />}>
          <Route element={<MainLayout />}>
            <Route path="/" element={<OrdersPage />} />
            <Route path="/inventario" element={<InventaryPage />} />
            <Route path="/precios" element={<PricesPage />} />

            {/* <Route path="/precios" element={<PricesPage />} /> */}
            <Route path="/catalogo" element={<CatalogPage />} /> 
            <Route path="/logs" element={<LogsPage />} />
            <Route path="/logs/:idLog" element={<DetailLogPage />} />
          </Route>
        </Route>
      </Routes>
    </main>
  )
}

export default App
